module.exports = __webpack_public_path__ + "static/media/lock-color-gray.4165579e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/lock-color-gray.svg
// module id = 756
// module chunks = 0